module.exports = __webpack_public_path__ + "static/img/zhongkong-yongdian.89edf5ec.png";